import script from "./productCondiments.vue?vue&type=script&lang=ts&setup=true"
export * from "./productCondiments.vue?vue&type=script&lang=ts&setup=true"

import "./productCondiments.vue?vue&type=style&index=0&id=4a635321&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a635321"]])

export default __exports__